var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#998CA6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7984 15.8266L11.7999 9.09692L5.33984 11.9317L11.7984 15.8266Z",
    fill: "#998CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.835 9.09692L11.8335 15.8282L18.2948 11.9317L11.835 9.09692Z",
    fill: "#998CA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2881 11.894L11.8335 1.28885L11.835 9.06219L18.2881 11.894Z",
    fill: "#998CA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8341 16.9274L11.8335 22.1225L18.3002 13.2196L11.8341 16.9274Z",
    fill: "#998CA6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7985 22.119L11.7991 16.9263L5.33447 13.2196L11.7985 22.119Z",
    fill: "#998CA6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34668 11.8941L11.8001 9.06225L11.7986 1.29299L5.34668 11.8941Z",
    fill: "#998CA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.817 15.875L11.8296 15.868L18.3387 11.9427L18.352 11.9348L11.8327 1.22256L11.8176 1.2L11.8021 1.22256L5.28223 11.9348L11.8046 15.8682L11.817 15.8753V15.875ZM18.2879 11.894L11.8348 9.06221L11.8336 1.28887L18.2879 11.894ZM11.8348 9.097L18.2946 11.9318L11.8336 15.8283L11.8348 9.097ZM11.7985 15.8267L5.33995 11.9318L11.8 9.097L11.7985 15.8267ZM5.34659 11.894L11.7985 1.29295L11.8 9.06221L5.34659 11.894Z",
    fill: "#998CA6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21729 13.1153L11.8055 22.1854L11.8173 22.2001L11.8294 22.1854L18.4173 13.1153L11.8173 16.8998L5.21729 13.1153ZM11.7986 22.1191L5.33454 13.2197L11.7992 16.9264L11.7986 22.1191ZM11.8339 16.9275L18.3 13.2197L11.8336 22.1226L11.8342 16.9275H11.8339Z",
    fill: "#998CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumDefault);
export default __webpack_public_path__ + "static/media/ethereumDefault.8c1e676dceddcb75f67af5bfb62d7585.svg";
export { ForwardRef as ReactComponent };